var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcChrome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4902_29040)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.2899 25.0002C88.9014 17.3999 82.5895 11.0885 74.9888 6.70054C67.3881 2.31253 58.7663 0.00244141 49.9899 0.00244141C41.2135 0.00244141 32.5917 2.31253 24.991 6.70054C17.3903 11.0885 11.0785 17.3999 6.68994 25.0002L9.68994 79.0002L93.2899 25.0002Z",
    fill: "url(#paint0_linear_4902_29040)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.35 62.5L6.69995 25C2.31159 32.6009 0.00127645 41.223 0.0012207 49.9997C0.00116496 58.7764 2.31137 67.3985 6.69963 74.9995C11.0879 82.6004 17.3996 88.9123 25.0004 93.3008C32.6012 97.6893 41.2232 99.9998 50 100L99 50L28.35 62.5Z",
    fill: "url(#paint1_linear_4902_29040)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.65 62.5L50 100C58.7759 99.998 67.3967 97.6863 74.996 93.297C82.5954 88.9078 88.9057 82.5957 93.2928 74.9951C97.6799 67.3945 99.9892 58.7731 99.9887 49.9972C99.9882 41.2213 97.6779 32.6001 93.29 25H50L71.65 62.5Z",
    fill: "url(#paint2_linear_4902_29040)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 75C53.283 75 56.5339 74.3534 59.5671 73.097C62.6002 71.8406 65.3562 69.9991 67.6777 67.6777C69.9991 65.3562 71.8406 62.6002 73.097 59.5671C74.3534 56.5339 75 53.283 75 50C75 46.717 74.3534 43.4661 73.097 40.4329C71.8406 37.3998 69.9991 34.6438 67.6777 32.3223C65.3562 30.0009 62.6002 28.1594 59.5671 26.903C56.5339 25.6466 53.283 25 50 25C43.3696 25 37.0107 27.6339 32.3223 32.3223C27.6339 37.0107 25 43.3696 25 50C25 56.6304 27.6339 62.9893 32.3223 67.6777C37.0107 72.3661 43.3696 75 50 75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 69.8002C52.6001 69.8002 55.1748 69.2881 57.5771 68.293C59.9793 67.298 62.1621 65.8395 64.0007 64.0009C65.8393 62.1623 67.2977 59.9796 68.2928 57.5773C69.2878 55.1751 69.8 52.6004 69.8 50.0002C69.8 47.4 69.2878 44.8253 68.2928 42.4231C67.2977 40.0208 65.8393 37.8381 64.0007 35.9995C62.1621 34.1609 59.9793 32.7024 57.5771 31.7074C55.1748 30.7123 52.6001 30.2002 50 30.2002C44.7487 30.2002 39.7125 32.2863 35.9992 35.9995C32.286 39.7127 30.2 44.7489 30.2 50.0002C30.2 55.2515 32.286 60.2877 35.9992 64.0009C39.7125 67.7141 44.7487 69.8002 50 69.8002Z",
    fill: "#1A73E8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4902_29040",
    x1: 6.69994,
    y1: 31.2502,
    x2: 93.2899,
    y2: 31.2502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D93025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA4335"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4902_29040",
    x1: 55.41,
    y1: 96.87,
    x2: 12.11,
    y2: 21.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E8E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34A853"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4902_29040",
    x1: 42.7,
    y1: 100,
    x2: 86,
    y2: 25.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCC934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBC04"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4902_29040"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChrome);
export default __webpack_public_path__ + "static/media/ic_chrome.e579fa1c8e24fd7924008de1fb6953ad.svg";
export { ForwardRef as ReactComponent };